var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldHideContainer)?_c('div'):(_vm.isInsideViewport)?_c('item-list',{ref:"item-list-content",staticClass:"row",style:({
    'min-height': (_vm.minimumHeight + "px"),
  }),attrs:{"tag":_vm.tag,"item-list":_vm.page.list},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var item = ref.item;
  var index = ref.index;
  var itemConfig = ref.itemConfig;
return [_vm._t("default",null,{"item":item,"index":index,"itemConfig":itemConfig})]}}],null,true)}):_c('div',{style:({
    width: '100%',
    height: (_vm.emptyDivHeight + "px"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }